(() => {
  const root = document.querySelector('[data-fauniva-gift]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const gift = root.querySelector('[data-fg-panel]');
  const offer = root.querySelector('[data-fo-panel]');
  const form = root.querySelector('form');
  const memory = {};
  const read = (storage, key) => { try { return window[storage].getItem(key); } catch (_) { return memory[key] || null; } };
  const write = (storage, key, value) => { memory[key] = value; try { window[storage].setItem(key, value); } catch (_) {} };
  const sessionKey = 'fauniva:gift:visit:v1';
  const dismissalKey = 'fauniva:gift:closed:v1';
  const subscribedKey = 'fauniva:gift:subscribed:v1';
  const pendingKey = 'fauniva:gift:pending:v1';
  const now = Date.now();
  let visit;
  try { visit = JSON.parse(read('sessionStorage', sessionKey)); } catch (_) {}
  if (!visit || !Number.isFinite(visit.elapsed) || !Number.isFinite(visit.last) || now - visit.last > 1800000) visit = { elapsed: 0, last: now, shown: false, dismissed: false };
  const saveVisit = () => { visit.last = Date.now(); write('sessionStorage', sessionKey, JSON.stringify(visit)); };
  const pending = Number(read('sessionStorage', pendingKey));
  const returned = pending > 0 && now - pending < 900000;
  const successful = returned && Boolean(root.querySelector('[data-fg-success]'));
  const failed = returned && Boolean(root.querySelector('[data-fg-error]'));
  if (successful) {
    write('localStorage', subscribedKey, 'true');
    write('localStorage', 'theme:popup-filled', 'true');
    write('sessionStorage', pendingKey, '0');
  }
  let subscribed = Boolean(root.querySelector('[data-fg-success]') && !returned) || root.dataset.subscribed === 'true' || read('localStorage', subscribedKey) === 'true' || read('localStorage', 'theme:popup-filled') === 'true';
  const editor = root.dataset.editor === 'true';
  const cooldown = Number(root.dataset.days || 3) * 86400000;
  const delay = Number(root.dataset.delay || 30) * 1000;
  const threshold = Number(root.dataset.scroll || 35) / 100;
  const controller = new AbortController();
  const on = (node, event, fn, options = {}) => node && node.addEventListener(event, fn, { ...options, signal: controller.signal });
  const controls = () => document.querySelectorAll('[data-fp-open]');
  const ownTarget = target => target instanceof Element && (root.contains(target) || target.closest('[data-fp-open]'));
  let active = null, previousFocus, cssReady, wanted, timer, frame, destroyed = false;
  let stamp = performance.now(), wasVisible = !document.hidden, busyUntil = 0, pointerDown = false, composing = false;
  let returnPending = successful || failed;
  const accrue = () => { const t = performance.now(); if (wasVisible) visit.elapsed += t - stamp; stamp = t; wasVisible = !document.hidden; };
  let closedAt = Number(read('localStorage', dismissalKey));
  const canAuto = () => {
    return !editor && root.dataset.autoEligible !== 'false' && !subscribed && !visit.shown && !visit.dismissed && !visit.purchaseIntent && !(closedAt > 0 && Date.now() - closedAt < cooldown);
  };
  const visible = el => Boolean(el && !el.hidden && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  const blockerSelector = 'dialog[open],.drawer[open],.modal[open],privacy-bar:not([hidden]),[role="dialog"][aria-modal="true"],#shopify-pc__banner,#shopify-pc__prefs,shopify-chat[is-open="true"],shopify-chat[open]';
  const blockerCandidatesSelector = 'dialog,.drawer,.modal,privacy-bar,[role="dialog"],#shopify-pc__banner,#shopify-pc__prefs,shopify-chat';
  let blockerCandidates;
  const invalidateBlockers = records => {
    if (!blockerCandidates) return;
    if (records.some(record => record.type === 'childList'
      ? [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1)
      : record.target.matches(blockerCandidatesSelector) || blockerCandidates.includes(record.target))) blockerCandidates = null;
  };
  const blockerObserver = typeof MutationObserver === 'function' ? new MutationObserver(invalidateBlockers) : null;
  blockerObserver?.observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'id', 'role']});
  const blocked = () => {
    if (document.hidden || composing || pointerDown || performance.now() < busyUntil) return true;
    if (document.activeElement && !ownTarget(document.activeElement) && document.activeElement.matches('input,textarea,select,[contenteditable="true"]')) return true;
    if (!blockerObserver) return Array.from(document.querySelectorAll(blockerSelector)).some(el => !root.contains(el) && visible(el));
    invalidateBlockers(blockerObserver.takeRecords());
    blockerCandidates ||= Array.from(document.querySelectorAll(blockerCandidatesSelector));
    return blockerCandidates.some(el => el.isConnected && el.matches(blockerSelector) && !root.contains(el) && visible(el));
  };
  const prepare = () => {
    if (!cssReady) cssReady = new Promise((resolve, reject) => {
      const link = document.createElement('link'); link.rel = 'stylesheet'; link.href = root.dataset.style;
      link.onload = resolve;
      link.onerror = () => { cssReady = null; link.remove(); reject(new Error('style')); };
      document.head.append(link);
    });
    return cssReady;
  };
  const syncControls = () => controls().forEach(el => {
    const panel = el.dataset.fpOpen === 'gift' ? gift : offer;
    if (panel) {
      el.setAttribute('aria-controls', panel.id);
      el.setAttribute('aria-haspopup', 'dialog');
      el.setAttribute('aria-expanded', String(active === panel));
    }
  });
  const fallbackFocus = kind => Array.from(controls()).find(el => el.dataset.fpOpen === kind && visible(el));
  const close = (dismiss = true, restore = true) => {
    wanted = null;
    const kind = active === offer ? 'offer' : 'gift';
    if (active === gift && dismiss) { visit.dismissed = true; closedAt = Date.now(); write('localStorage', dismissalKey, String(closedAt)); }
    gift.hidden = true; if (offer) offer.hidden = true;
    active = null; delete root.dataset.open; syncControls(); accrue(); saveVisit(); arm();
    const target = previousFocus && previousFocus.isConnected && visible(previousFocus) ? previousFocus : fallbackFocus(kind);
    if (restore && target) target.focus({ preventScroll: true });
  };
  const scrollEnough = () => { const range = document.documentElement.scrollHeight - innerHeight; return range > 0 && scrollY / range > threshold; };
  const open = async (panel, manual = false) => {
    if (!panel || blocked() || destroyed) return null;
    const token = {}; wanted = token;
    try { await prepare(); } catch (_) { return false; }
    if (wanted !== token || destroyed || blocked()) return null;
    if (!manual && !returnPending && (!canAuto() || !scrollEnough())) return false;
    gift.hidden = true; if (offer) offer.hidden = true;
    active = panel; root.dataset.open = panel === gift ? 'gift' : 'offer'; panel.hidden = false; syncControls();
    panel.querySelectorAll('img[data-fg-src]').forEach(img => {
      if (img.dataset.fgSrcset) img.srcset = img.dataset.fgSrcset;
      img.src = img.dataset.fgSrc; delete img.dataset.fgSrc; delete img.dataset.fgSrcset;
    });
    returnPending = false; visit.shown = true; accrue(); saveVisit(); clearTimeout(timer);
    if (manual) panel.focus({ preventScroll: true });
    return true;
  };
  const evaluate = () => {
    if (destroyed) return;
    const obstructed = blocked();
    if (root.dataset.obscured !== String(obstructed)) root.dataset.obscured = String(obstructed);
    if (active) {
      if (obstructed && !pointerDown && performance.now() >= busyUntil) close(false, false);
      return;
    }
    if (obstructed) return;
    if (returnPending) { previousFocus = fallbackFocus('gift'); open(gift, true); return; }
    if (canAuto()) { accrue(); if (visit.elapsed >= delay && scrollEnough()) { previousFocus = fallbackFocus('gift'); open(gift); } }
  };
  const schedule = () => { if (!frame && !destroyed) frame = requestAnimationFrame(() => { frame = null; evaluate(); }); };
  const arm = () => {
    clearTimeout(timer);
    if (destroyed || document.hidden || !canAuto()) return;
    accrue();
    if (visit.elapsed < delay) timer = setTimeout(() => { accrue(); saveVisit(); evaluate(); arm(); }, Math.max(20, delay - visit.elapsed + 25));
  };
  on(document, 'click', async event => {
    const trigger = event.target instanceof Element && event.target.closest('[data-fp-open]');
    if (!trigger || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const panel = trigger.dataset.fpOpen === 'gift' ? gift : offer;
    if (!panel) return;
    event.preventDefault();
    if (blocked()) return;
    previousFocus = trigger;
    const opened = await open(panel, true);
    if (opened === false && !destroyed && !blocked() && trigger.tagName === 'A' && trigger.dataset.fpOpen !== 'gift') window.location.assign(trigger.href);
  }, { capture: true });
  root.querySelectorAll('[data-fg-close],[data-fo-close]').forEach(el => on(el, 'click', () => close()));
  on(document, 'keydown', event => { if (event.key === 'Escape' && active) { event.preventDefault(); close(); } });
  on(form, 'submit', () => { write('sessionStorage', pendingKey, String(Date.now())); accrue(); saveVisit(); });
  const purchase = () => { visit.purchaseIntent = true; accrue(); saveVisit(); clearTimeout(timer); if (active) close(false, false); };
  on(document, 'variant:add', purchase);
  on(document, 'cart:change', event => { if (event.detail && event.detail.baseEvent === 'variant:add') purchase(); schedule(); });
  let startY, startX, swipePanel;
  on(root, 'pointerdown', event => {
    if (!matchMedia('(max-width:699px)').matches || !active || event.target.closest('input,button,a,textarea,select') || active.scrollTop > 0) return;
    startY = event.clientY; startX = event.clientX; swipePanel = active;
  }, { passive: true });
  on(window, 'pointerup', event => {
    pointerDown = false;
    if (active && swipePanel === active && event.clientY - startY > 55 && Math.abs(event.clientX - startX) < 70) close();
    swipePanel = null; busyUntil = ownTarget(event.target) ? 0 : performance.now() + 250;
    setTimeout(schedule, 300);
  }, { passive: true });
  on(document, 'pointerdown', event => { if (!ownTarget(event.target)) pointerDown = true; }, { passive: true });
  on(window, 'pointercancel', () => { pointerDown = false; swipePanel = null; setTimeout(schedule, 300); }, { passive: true });
  on(document, 'compositionstart', event => { if (!ownTarget(event.target)) composing = true; });
  on(document, 'compositionend', () => { composing = false; schedule(); });
  on(document, 'focusin', schedule);
  on(document, 'focusout', () => setTimeout(schedule, 300));
  on(window, 'scroll', () => { if (active || returnPending || canAuto()) schedule(); }, { passive: true });
  on(document, 'close', schedule, { capture: true });
  on(document, 'toggle', schedule, { capture: true });
  on(document, 'dialog:after-show', schedule);
  on(document, 'dialog:after-hide', schedule);
  on(document, 'visitorConsentCollected', () => setTimeout(schedule, 300));
  on(document, 'visibilitychange', () => { accrue(); saveVisit(); arm(); schedule(); });
  const adjustEdge = () => {
    if (matchMedia('(max-width:989px)').matches) return;
    let gutter = 28;
    for (const el of document.querySelectorAll('main .fauniva-shell,main .container')) {
      const rect = el.getBoundingClientRect();
      if (!rect.width) continue;
      const left = rect.left + parseFloat(getComputedStyle(el).paddingLeft || 0);
      if (left > 0) { gutter = left; break; }
    }
    const edge = Math.max(16, Math.min(22, Math.floor(gutter - 6))) + 'px';
    if (root.style.getPropertyValue('--fg-edge') !== edge) root.style.setProperty('--fg-edge', edge);
  };
  const viewport = () => {
    const v = window.visualViewport;
    const inset = `${v ? Math.max(0, innerHeight - v.height - v.offsetTop) : 0}px`;
    if (root.style.getPropertyValue('--fg-keyboard') !== inset) root.style.setProperty('--fg-keyboard', inset);
    schedule();
  };
  on(window, 'resize', () => { adjustEdge(); viewport(); }, { passive: true });
  on(window.visualViewport, 'resize', viewport, { passive: true });
  on(window.visualViewport, 'scroll', viewport, { passive: true });
  on(window, 'pagehide', () => { accrue(); saveVisit(); clearTimeout(timer); });
  on(window, 'pageshow', event => { if (event.persisted) { stamp = performance.now(); wasVisible = !document.hidden; arm(); schedule(); } });
  on(window, 'storage', event => {
    if (event.key === subscribedKey && event.newValue === 'true') { subscribed = true; clearTimeout(timer); if (active === gift) close(false, false); }
    if (event.key === dismissalKey) { closedAt = Number(event.newValue); arm(); schedule(); }
  });
  let nudgeObserver;
  const nudgeKey = 'fauniva:promo:nudged:v1';
  const nudgeTarget = document.querySelector('.fauniva-spotlight [data-fp-open="gift"]');
  if (!editor && nudgeTarget && 'IntersectionObserver' in window && matchMedia('(max-width:989px)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches && !read('sessionStorage', nudgeKey)) {
    nudgeObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      nudgeTarget.classList.add('fp-nudge'); write('sessionStorage', nudgeKey, 'true'); nudgeObserver.disconnect();
    }, { threshold: .8 });
    nudgeObserver.observe(nudgeTarget);
  }
  on(document, 'shopify:section:load', () => { syncControls(); adjustEdge(); });
  on(document, 'shopify:section:unload', event => {
    if (!event.target.contains(root)) return;
    destroyed = true; wanted = null; clearTimeout(timer); cancelAnimationFrame(frame); if (nudgeObserver) nudgeObserver.disconnect(); blockerObserver?.disconnect(); controller.abort();
  });
  if (editor) {
    on(document, 'shopify:section:select', event => { if (event.target.contains(root)) open(gift, true); });
    on(document, 'shopify:section:deselect', event => { if (event.target.contains(root)) close(false, false); });
  }
  syncControls(); saveVisit(); adjustEdge(); viewport(); arm();
})();
